<template>
    <div>
        <qrvey-builders v-if="$store.state.user.qrveyapp_id.length" settings="config"></qrvey-builders>
    </div>
</template>

<script>


export default {
    mounted() {
        this.$store.watch(state => {
            if (state.user.qrveyapp_id.length) {
                window.config.app_id = state.user.qrveyapp_id
                window.config.user_id = 'NjCyf_2pp'
            }
        })
    }
}
</script>

<style scoped>

</style>